/**
 * 自定义指令
 */
import permission from './permission'

const install = function (Vue) {
  Vue.directive('permission', permission)

  /**
   * 全半角转换指令
   */
  Vue.directive('angle', {
    inserted: function (el, binding, vnode) {
      el.children[0].value = binding.value === undefined ? '' : binding.value
      let angleValue = el.children[0]
      el.addEventListener('keyup', function (e) {
        e = e || window.event
        let str = angleValue.value
        let tmp = ''
        // str = str.replace(/：/g, ':')
        // str = str.replace(/。/g, '.')
        // str = str.replace(/“/g, '"')
        // str = str.replace(/”/g, '"')
        // str = str.replace(/【/g, '[')
        // str = str.replace(/】/g, ']')
        // str = str.replace(/《/g, '<')
        // str = str.replace(/》/g, '>')
        // str = str.replace(/，/g, ',')
        // str = str.replace(/？/g, '?')
        // str = str.replace(/、/g, ',')
        // str = str.replace(/；/g, ';')
        // str = str.replace(/（/g, '(')
        // str = str.replace(/）/g, ')')
        // str = str.replace(/‘/g, "'")
        // str = str.replace(/’/g, "'")
        // str = str.replace(/『/g, '[')
        // str = str.replace(/』/g, ']')
        // str = str.replace(/「/g, '[')
        // str = str.replace(/」/g, ']')
        // str = str.replace(/﹃/g, '[')
        // str = str.replace(/﹄/g, ']')
        // str = str.replace(/〔/g, '{')
        // str = str.replace(/〕/g, '}')
        // str = str.replace(/—/g, '-')
        // str = str.replace(/·/g, '.')
        str = str.replace(/\s+/g, '')
        /* 正则转换全角为半角 */
        for (var i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) === 12288) {
            tmp += String.fromCharCode(str.charCodeAt(i) - 12256)
            continue
          }
          if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
            tmp += String.fromCharCode(str.charCodeAt(i) - 65248)
          } else {
            tmp += String.fromCharCode(str.charCodeAt(i))
          }
        }
        vnode.data.model.callback(tmp)
      })
    },
  })

  /**
   * 全半角转换指令-数字篇
   */
  Vue.directive('number', {
    inserted: function (el, binding, vnode) {
      el.children[0].value = binding.value === undefined ? '' : binding.value
      let angleValue = el.children[0]
      el.addEventListener('keyup', function (e) {
        e = e || window.event
        let tmp = ''
        let str = angleValue.value
        const regexp = new RegExp(`^[0-9][0-9]{0,3}$`)
        for (var i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) === 12288) {
            const code1 = String.fromCharCode(str.charCodeAt(i) - 12256)
            if (regexp.test(code1)) tmp += code1
            continue
          }
          if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
            const code2 = String.fromCharCode(str.charCodeAt(i) - 65248)
            if (regexp.test(code2)) tmp += code2
          } else {
            const code3 = String.fromCharCode(str.charCodeAt(i))
            if (regexp.test(code3)) tmp += code3
          }
        }
        if (tmp) {
          tmp = parseInt(tmp.trim()) > 9999 ? parseInt(tmp.trim().substring(0, 4)) : parseInt(tmp.trim())
        } else {
          tmp = ''
        }
        vnode.data.model.callback(tmp)
      })
    },
  })
}

export default install
